// The deliberately loose "looks like an email address" rule for addresses a
// person types: plus tags, any-script local parts and internationalized
// domains pass; whitespace, a missing or doubled @ and domains that can't be
// a DNS name don't. Mirrors user-service's EmailAddress; both are pinned by
// common-contracts/email_address.json. Whether the domain takes mail is
// checked by the server only.
//
// Not `<input type="email">`'s own check (or Yup's `.email()`): that rule is
// ASCII-only, so it turns away real addresses on internationalized domains.

export const MAX_LOCAL_PART_BYTES = 64;
export const MAX_LABEL_LENGTH = 63;
export const MAX_DOMAIN_LENGTH = 253;

const LOCAL_PART = /^[^\s@\p{Cc}]+$/u;
const LABEL = /^[\p{L}\p{M}\p{N}](?:[\p{L}\p{M}\p{N}-]*[\p{L}\p{M}\p{N}])?$/u;
const NUMERIC = /^\p{N}+$/u;

export const isEmailAddress = (address: string): boolean => {
  const parts = address.trim().split('@');
  if (parts.length !== 2) return false;
  const [local, domain] = parts;

  if (new TextEncoder().encode(local).length > MAX_LOCAL_PART_BYTES || !LOCAL_PART.test(local)) return false;
  // Ruby's String#length counts code points; so does the spread.
  if ([...domain].length > MAX_DOMAIN_LENGTH) return false;

  const labels = domain.split('.');
  return (
    labels.length >= 2 &&
    labels.every((label) => [...label].length <= MAX_LABEL_LENGTH && LABEL.test(label)) &&
    !NUMERIC.test(labels[labels.length - 1])
  );
};
